<template>
  <div>
    <div class="head_box flex_start flex_center_align">
      <img src="~@/assets/images/r2.png" alt="" />
      <span class="hd_title">
        <slot name="hd_title">報告書一覧</slot>
      </span>
    </div>
    <div class="filelist_box">
      <span class="f_title">
        <slot name="f_title">報告書の提出を行ってください</slot>
      </span>
    </div>
    <div v-for="(row, index) in fileList" :key="index" class="file_box_new">
      <div class="header_box flex_start flex_center_align">
        <span class="title">
          {{ row.docName }}
        </span>
        <vab-upload
          v-if="!row.btnDisabled && !view"
          :batch-url="row.uploadAllUrl"
          :disabled="disabledMoreUpload(row.list[0].fileList)"
          :params-data="row"
          :multiple="true"
          :btn-name="btnName"
          :su-ts="false"
          @on-change="uploadChange"
          @on-success-bath="(res) => successFileBath(res, row)"
        />
      </div>
      <div
        v-if="disabledMoreUpload(row.list[0].fileList)"
        class="file_item_box"
        :class="{ flex_space: row.list && row.list.length > 1 }"
      >
        <div class="border_ae1">
          <div
            v-if="row.requiredFlg == 2 && row.prestatusName"
            class="state_box_off"
          >
            <div class="col_content_cont">
              <div
                class="flex_start box_st"
                :class="{
                  changeBox: isEqualCodeEnum(
                    row.preReportStatus,
                    $divisions.reportStatusEnum.enum_04
                  ),
                }"
              >
                <svg-icon
                  :icon-class="
                    isEqualCodeEnum(
                      row.officalReportStatus,
                      $divisions.reportStatusEnum.enum_04
                    )
                      ? 'cha'
                      : 'dui'
                  "
                />
                <span class="mark">{{ row.prestatusName }}</span>
              </div>
            </div>
          </div>
          <div
            v-if="row.requiredFlg == 1 && row.offstatusName"
            class="state_box_off"
          >
            <div class="col_content_cont">
              <div
                class="flex_start box_st"
                :class="{
                  changeBox: isEqualCodeEnum(
                    row.officalReportStatus,
                    $divisions.reportStatusEnum.enum_04
                  ),
                }"
              >
                <svg-icon
                  :icon-class="
                    isEqualCodeEnum(
                      row.officalReportStatus,
                      $divisions.reportStatusEnum.enum_04
                    )
                      ? 'cha'
                      : 'dui'
                  "
                />
                <span class="mark">{{ row.offstatusName }}</span>
              </div>
            </div>
          </div>
          <div
            v-for="(item, cIndex) in row.list"
            :key="cIndex"
            :class="{ more_colum: row.list.length > 1 }"
            class="file_item"
          >
            <div
              v-if="changeFileList(item.fileList).length"
              class="pdtb4 flex_colum"
            >
              <div
                v-for="(file, f) in item.fileList"
                :key="f"
                class="file_inner_item flex_start psr"
              >
                <template
                  v-if="
                    file.operationType !=
                    $divisions.operationTypeEnum.enum_D.value
                  "
                >
                  <svg-icon icon-class="tryangle_right" class="arrow" />
                  <div class="flex_colum file_name_box">
                    <span class="file_name" @click="downLoad(row, file)">
                      {{ file.fileName }}
                    </span>
                    <div class="file_time">
                      アップロード日時：{{ file.createDate }}&nbsp;
                      {{ file.createTime.substring(0, 8) }}
                      &nbsp;|&nbsp;
                      {{
                        getEnumText(
                          file.submitSourceClass,
                          $divisions.adjSourceClassEnum
                        )
                      }}
                    </div>
                    <svg-icon
                      v-if="deleteShow(row, file)"
                      icon-class="close_circle_fill"
                      class="del"
                      @click="deleteFile(row, file, item, f)"
                    />
                  </div>
                  <div class="header_box file_item_btn_box pos_right">
                    <vab-upload
                      v-if="!row.btnDisabled && !view"
                      :upload-url="row.uploadUrl"
                      :params-data="{ ...row, fileId: file.fileId }"
                      :multiple="false"
                      :su-ts="false"
                      :btn-name="file.btnName"
                      @on-success="(res) => rowSuccessFile(res, row, file, f)"
                    />
                  </div>
                </template>
              </div>
              <div class="header_box file_item_btn_box file_bottom_btn">
                <vab-upload
                  v-if="!row.btnDisabled && !view"
                  :upload-url="row.uploadUrl"
                  :params-data="row"
                  :multiple="false"
                  :su-ts="false"
                  :btn-name="item.btnName"
                  @on-success="(res) => successFile(res, row)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import request from '@/utils/request'
  import { reportUrgeOne } from '@/api/rc/PWR02G06'
  import download from '@/utils/download'

  export default {
    name: 'VabFilerc',
    props: {
      nofile: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        btnName: '一括アップロード',
        fileList: [],
        fileListAll: [],
        uploadList: [],
        paramsData: {},
        progressIndex: null,
        view: false,
      }
    },
    computed: {
      changeFileList() {
        return (list) => {
          return list.filter(
            (item) =>
              item.operationType !=
              this.$divisions.operationTypeEnum.enum_D.value
          )
        }
      },
      disabledMoreUpload() {
        return (list) => {
          return list.filter(
            (item) =>
              item.operationType !=
              this.$divisions.operationTypeEnum.enum_D.value
          ).length > 0
            ? true
            : false
        }
      },
      deleteShow() {
        return (row, file) => {
          return file.delCheck && !row.btnDisabled && this.delSvgShow(file)
        }
      },
    },
    methods: {
      delSvgShow(file) {
        let reportSubmitStatusList = [
          this.$divisions.reportStatusEnum.enum_21.value,
          this.$divisions.reportStatusEnum.enum_22.value,
        ]
        if (reportSubmitStatusList.includes(file.reportStatus)) {
          return false
        } else {
          return true
        }
      },
      showUrgeBtn(row) {
        return (
          ((this.isEqualCodeEnum(
            row.officalReportStatus,
            this.$divisions.reportStatusEnum.enum_00
          ) ||
            this.isEqualCodeEnum(
              row.officalReportStatus,
              this.$divisions.reportStatusEnum.enum_01
            )) &&
            this.isEqualCodeEnum(
              row.reportTypeFlag,
              this.$divisions.reportTypeFlagEnum.enum_1
            )) ||
          ((this.isEqualCodeEnum(
            row.preReportStatus,
            this.$divisions.reportStatusEnum.enum_00
          ) ||
            this.isEqualCodeEnum(
              row.preReportStatus,
              this.$divisions.reportStatusEnum.enum_01
            )) &&
            this.isEqualCodeEnum(
              row.reportTypeFlag,
              this.$divisions.reportTypeFlagEnum.enum_0
            ))
        )
      },
      uploadChange(file, fileList) {
        this.fileListAll = fileList
      },
      // ファイルリストを設定する
      setList(list, vm) {
        this.fileList = list
        this.vm = vm
      },
      initData(data) {
        this.paramsData = data
        if (data?.view) {
          this.view = data?.view
        }
      },
      // アップロード成功コールバック
      successFileBath(fileList, row) {
        fileList.filter((res) => {
          this.vm.setFileList(res, row)
        })
      },
      // アップロード成功コールバック
      successFile(res, row) {
        this.vm.setFileList(res, row)
      },
      // アップロード成功コールバック
      rowSuccessFile(res, row, file, f) {
        this.vm.setRowFileList(res, row, file, f)
      },
      // 報告書ダウンロード
      async downLoad(row, file) {
        download.resource(`/api/reportFileRc/download`, file, null)
      },
      async submitDelFile(row, file, item, index) {
        let res = await request({
          url: `/api/reportFileRc/deleteFile`,
          data: file,
          method: 'post',
        })
        if (res) {
          this.msgSuccess(
            this.$t(`validateMessage.${this.$messageCode.I00000414.name}`)
          )
          this.vm.deleteBookFileList(row, index, res)
        }
      },
      // ファイルを削除
      deleteFile(row, file, item, index) {
        this.$confirm({
          msg: this.$t(`validateMessage.${this.$messageCode.I00000412.name}`),
          yesText: 'ok',
          yes: () => {
            this.submitDelFile(row, file, item, index)
          },
        })
      },
      async reportUrge(row) {
        const res = await reportUrgeOne({
          reportId: row.reportId,
          urgeType: row.reportTypeFlag,
        })

        if (!res) {
          this.msgSuccess(
            this.$t(`validateMessage.${this.$messageCode.I00000453.name}`)
          )
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import '@/vab/styles/reportRc.scss';
</style>
<style lang="scss" scoped>
  .mark {
    margin-left: 5px;
  }
  .state_box_grey {
    background: #f7f7f7;
    border: 1px solid #848484;
    margin-left: 12px;
    padding: 6px;
    color: #848484;
  }
  .state_box_red {
    background: #fff6f6;
    border: 1px solid #c90022;
    margin-left: 12px;
    padding: 6px;
    color: #c90022;
  }
  .state_box_blue {
    background: #ecf5ff;
    border: 1px solid #0060c2;
    margin-left: 12px;
    padding: 6px;
    color: #0060c2;
  }

  .upload_item_btn {
    color: #0060c2;
    padding: 6px 10px 6px 10px;
    display: inline-block;
    border: 1px solid #0060c2;
    border-radius: 3px;
    margin-top: 10px;
    line-height: normal;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
  }

  .psr {
    position: relative;
  }

  .file_box_new {
    padding: 12px;
    background: #f7f7f7;
    border-radius: 4px;
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
    .header_box {
      padding-bottom: 0px;
      .title {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        margin-right: 12px;
        i {
          color: red;
        }
      }
      .upload_btn {
        background: #0060c2;
        border-radius: 3px;
        padding: 8px 7px;
        display: inline-block;
        font-weight: 500;
        font-size: 13px;
        color: #ffffff;
        cursor: pointer;
        display: flex;
        align-items: center;
        .name {
          display: inline-block;
          padding-left: 8px;
        }
        &:hover {
          background: #0071ee;
        }
      }
    }
    .file_item {
      padding: 0 12px;
      background: #ffffff;
      border: none;
      width: 100%;
      margin-top: 0px;
      &.more_colum {
        margin-right: 12px;
        width: 100%;
        max-width: 50%;
        &:last-child {
          margin-right: 0px;
        }
      }
      .company {
        padding: 11px 0;
        border-bottom: 1px solid #d1dae1;
        .user {
          color: #848484;
          font-size: 19px;
        }
        .name {
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          color: #848484;
          padding-left: 4px;
        }
        .state_box {
          background: #f7f7f7;
          border: 1px solid #848484;
          margin-left: 12px;
          padding: 6px;
          color: #848484;
          cursor: pointer;
          .check_icon {
            width: 19px;
          }
          .mark {
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            padding-left: 3px;
          }
        }
      }
      .file_inner_item {
        padding: 8px 0;
        border-bottom: 1px dashed #d1dae1;
        .file_name_box {
          padding-right: 30px;
          position: relative;
          .file_name {
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            text-decoration-line: underline;
            color: #004c82;
            cursor: pointer;
          }
          .file_time {
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            color: #848484;
            padding-top: 4px;
          }
          .del {
            width: 20px;
            height: 20px;
            position: absolute;
            right: 0;
            top: 50%;
            margin-top: -10px;
            cursor: pointer;
          }
        }
        .arrow {
          color: #8ba6ba;
          width: 15px;
          min-width: 15px;
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
  .border_ae1 {
    border: 1px solid #d1dae1;
    border-radius: 4px;
  }

  .file_urge_btn {
    cursor: pointer;
    border-radius: 3px;
    padding: 6px;
    background: #fff;
    color: #0060c2;
    border: 1px solid #0060c2;
    margin-left: 8px;
    height: 28px;
    &:hover {
      border: 1px solid #0071ee;
      color: #0071ee;
    }
    .svg-icon {
      color: #0060c2 !important;
    }
  }
</style>
